import React, { Component } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tracking from 'utils/tracking';

import PlaylistWrapper from 'components/playlist-wrapper';
import MetadataWrapper from 'components/metadata-wrapper';
import {
    PlaybackPageTemplate,
    Ad,
} from 'web-media-ui-component';
import PlaybackPagePlayer from 'components/playback-page-player';
import DisplayAds from 'utils/display-ads';

class PlaybackPage extends Component {

    constructor(props) {

        super(props);

        const {
            clipData,
            list,
        } = this.props;

        this.state = {
            playlistItems: _isEmpty(clipData)
                ? []
                : [
                    clipData,
                    ...list.filter(item => item.id !== clipData.id),
                ],
        };

    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (
            _isEmpty(prevState.playlistItems)
            && !_isEmpty(nextProps.clipData)
        ) {

            return {
                playlistItems: [
                    nextProps.clipData,
                    ...nextProps.list.filter(item => item.id !== nextProps.clipData.id),
                ],
            };

        }

        return null;

    }

    componentDidMount() {

        const {
            clipData,
            match,
            getPageData,
            location,
            displayAdConfig,
        } = this.props;

        const contentId = match.params.contentId;
        const urlParams = new URLSearchParams(location.search);
        const topicId = urlParams.get('t');
        window.clipData = clipData;
        window.scrollTo({
            top: 0,
        });

        getPageData(contentId, topicId);

        DisplayAds.init(displayAdConfig);
        Tracking.trackPlaybackPageView();
    }

    componentDidUpdate(prevProps) {

        const {
            match,
            getClipData,
            setClipData,
            clipData,
            list,
            mediaConfig,
            lang,
            topicTitle
        } = this.props;

        const contentId = match.params.contentId;
        const prevContentId = prevProps.match.params.contentId;

        if (
            contentId !== prevContentId
            && contentId !== clipData.id
        ) {

            const clipDataInList = list.find(item => item.id === contentId);

            if (clipDataInList) {

                setClipData(clipDataInList);

            } else {

                getClipData(contentId);

            }

        }
        if (document && clipData.id !== prevProps.clipData.id) {
            
            window.clipData = clipData;
            const currentTitle = document.title;
            document.title = this.buildPageTitle(currentTitle, clipData, mediaConfig, lang);
            Tracking.trackPlaybackPageView(clipData, topicTitle);

        }

    }

    componentWillUnmount() {

        const {
            resetClipData,
            displayAdConfig,
        } = this.props;

        resetClipData();

        DisplayAds.destroySlots(displayAdConfig);

    }

    playlistItemClickHandler = (data, slug) => {

        const {
            setClipData,
            topic,
            history,
        } = this.props;

        const topicSlug = _get(topic, 'slug');
        const search = topicSlug ? `?t=${topicSlug}` : '';
        const pathname = `/${slug}`;

        setClipData(data);

        history.push({
            pathname,
            search,
        });

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

    }

    onNextClipDataLoadedHandler = (clipData) => {

        const {
            history,
            location,
            setClipData,
        } = this.props;

        setClipData(clipData);

        history.push({
            pathname: `/${clipData.id}`,
            search: location.search,
        });

    }

    onAdStartedEventHandler = (adConfig, ad) => {

        const googleIMA = _get(window, 'google.ima');

        if(!googleIMA) {

            return false;

        }

        const ciuSzs = _get(adConfig, 'ciu_szs', '').split(',');

        const selectionCriteria = new googleIMA.CompanionAdSelectionSettings();
        selectionCriteria.resourceType = googleIMA.CompanionAdSelectionSettings.ResourceType.STATIC;
        selectionCriteria.creativeType = googleIMA.CompanionAdSelectionSettings.CreativeType.IMAGE;
        selectionCriteria.sizeCriteria = googleIMA.CompanionAdSelectionSettings.SizeCriteria.IGNORE;

        ciuSzs.forEach((ciuSz) => {

            const ciuSzData = ciuSz.split('x');
            const ciuSzWidth = ciuSzData[0];
            const ciuSzHeight = ciuSzData[1];

            // Get a list of companion ads for an ad slot size and CompanionAdSelectionSettings
            const companionAds = ad.getCompanionAds(ciuSzWidth, ciuSzHeight, selectionCriteria);

            // Grab first companion ad found in list
            const companionAd = _get(companionAds, '[0]');

            // Get HTML content from the companion ad
            const companionAdContent = companionAd ? companionAd.getContent() : '';

            // Get ad slot based on ciu sz
            const adSlotElement = document.querySelector(`.p-ad .ad-responsive-size[data-sizes="[[${ciuSzWidth},${ciuSzHeight}]]"]`);

            if(adSlotElement) {

                // Write the companion ad content to the companion ad slot element.

                adSlotElement.innerHTML = `<div class='companion-ad-wrapper'>${companionAdContent}</div>`;

            }

        });

    }

    buildPageTitle = (currentTitle, clipData, mediaConfig, lang = 'en') => {
        const currentTitleRight = currentTitle.substring(currentTitle.lastIndexOf('| '));
        const newTitle = _get(clipData, 'title', clipData.blurb);
        const titleDateFormatEN = _get(mediaConfig, 'app.titleDateFormat.en', 'MM/DD/YYYY');
        const titleDateFormatES = _get(mediaConfig, 'app.titleDateFormat.es', 'DD/MM/YYYY');
        const titleDateFormat = (lang === 'es') ? titleDateFormatES : titleDateFormatEN;
        const date = moment(clipData.date).format(titleDateFormat);

        return `${newTitle} | ${date} ${currentTitleRight}`;

    }

    render() {
        
        const {
            clipData,
            clientSideReady,
            club,
            isClubPage,
            mediaConfig,
            topicTitle,
            topicId,
            topic,
            lang,
            displayAdConfig,
            deviceInfo,
            itemsBasePath,
            dictionary,
            mbox,
        } = this.props;
        const player = (
            <PlaybackPagePlayer
                container={'playback-page-player'}
                clientSideReady={clientSideReady}
                club={club}
                isClubPage={isClubPage}
                lang={lang}
                topicId={topicId}
                mediaConfig={mediaConfig}
                clipData={clipData}
                list={this.state.playlistItems.slice(1)}
                onNextClipDataLoaded={this.onNextClipDataLoadedHandler}
                onAdStartedEvent={this.onAdStartedEventHandler}
                deviceInfo={deviceInfo}
                mbox={mbox}
            />
        );
        const metadata = <MetadataWrapper clipData={clipData} lang={lang} dictionary={dictionary} mediaConfig={mediaConfig} />;
        const pageTargeting = DisplayAds.updatePageTargetingPageIdWithTopicId(displayAdConfig, topicId);
        const isResponsive = _get(displayAdConfig, 'responsive');

        const playlistAdConfig = DisplayAds.lookupDisplayAd(displayAdConfig, 'playlist-ad');
        const playlistAd = (
            <Ad
                pageTargeting={pageTargeting}
                isResponsive
                adSlots={_get(playlistAdConfig, 'slots')}
                targeting={_get(playlistAdConfig, 'targeting')}
            />
        );

        const playlist = (
            <PlaylistWrapper
                topicTitle={topicTitle}
                list={this.state.playlistItems}
                clipId={clipData.id}
                onItemClick = {this.playlistItemClickHandler}
                itemsBasePath={this.props.itemsBasePath}
                topic={topic}
                sponsorshipAd={playlistAd}
                lang={lang}
                dictionary={dictionary}
            />
        );

        const companionAdConfig = DisplayAds.lookupDisplayAd(displayAdConfig, 'companion-ad');
        const companionAd = (
            <Ad
                pageTargeting={pageTargeting}
                isResponsive={isResponsive}
                adSlots={_get(companionAdConfig, 'slots')}
                targeting={_get(companionAdConfig, 'targeting')}
                syncWithVideoAd={_get(companionAdConfig, 'syncWithVideoAd')}
            />
        );

        const skinAdConfig = DisplayAds.lookupDisplayAd(displayAdConfig, 'skin-ad');
        const skinAd = (
            <Ad
                pageTargeting={pageTargeting}
                isResponsive={isResponsive}
                adSlots={_get(skinAdConfig, 'slots')}
                targeting={_get(skinAdConfig, 'targeting')}
                isOutOfPage={_get(skinAdConfig, 'isOutOfPage')}
            />
        );

        return (
            <PlaybackPageTemplate
                player={player}
                metadata={metadata}
                companionAd={companionAd}
                playlist={playlist}
                skinAd={skinAd}
                mediaConfig={mediaConfig}
            />
        );

    }

}

PlaybackPage.propTypes = {
    getClipData: PropTypes.func.isRequired,
    setClipData: PropTypes.func.isRequired,
    resetClipData: PropTypes.func.isRequired,
    getPageData: PropTypes.func.isRequired,
    itemsBasePath: PropTypes.string.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            contentId: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    clientSideReady: PropTypes.bool.isRequired,
    club: PropTypes.string.isRequired,
    isClubPage: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    topicId: PropTypes.string.isRequired,
    clipData: PropTypes.shape(),
    mediaConfig: PropTypes.shape(),
    topicTitle: PropTypes.string,
    list: PropTypes.array,
    displayAdConfig: PropTypes.shape(),
    deviceInfo: PropTypes.shape(),
    dictionary: PropTypes.object,
    mbox: PropTypes.object,
};

PlaybackPage.defaultProps = {
    clipData: {},
    itemsBasePath: '/video',
    mediaConfig: {},
    topicTitle: '',
    list: [],
    displayAdConfig: {},
    deviceInfo: {},
    dictionary: {},
    mbox: {},
};

export default PlaybackPage;
